import { render, staticRenderFns } from "./CreateSkillModal.vue?vue&type=template&id=54406cd6&"
import script from "./CreateSkillModal.vue?vue&type=script&lang=js&"
export * from "./CreateSkillModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports